// check
export const SEARCH_CHANGE_EVENT = 'searchChangeEvent';
export const TABLE_CONTROLS_CHANGE_EVENT = 'tableControlsChangeEvent';
export const PAGING_CHANGE_HANDLER = 'pagingChangeHandler';
export const SEARCH_TARGET_DEVICE_EVENT = 'searchTargetDeviceEvent';
export const LOAD_TABLE_COMPLETE_EVENT = 'loadTableCompleteEvent';

// update
export const SOLUTION_PORTFOLIO_TABLE_DATA_UPADTED_EVENT = 'SolutionPortfolioTableDataUpdatedEvent';
export const TABLE_DATA_UPDATED_EVENT = 'tableDataUpdatedEvent';
export const MANAGE_BUTTON_STATUS_UPDATE_EVENT = 'manageButtonStatusUpdateEvent';

// click & select
export const UN_SELECT_ALL_EVENT = 'unSelectAllEvent';
export const FILTER_CLICK_EVENT = 'filterClickEvent';
export const FILTER_CLOSE_EVENT = 'filterCloseEvent';
export const ORDER_CLICK_EVENT = 'orderClickEvent';
export const ITEM_CHECKED_EVENT = 'itemCheckedEvent';
export const DEVICE_SELECTED_EVENT = 'deviceSelectedEvent';
export const LOG_BUTTON_CLICK_EVENT = 'logsButtonClickEvent';
export const DISABLE_BUTTON_EVENT = 'disableButtonEvent';
export const ENABLE_BUTTON_EVENT = 'enableButtonEvent';


// refresh
export const REFRESH_TABLE_EVENT = 'refreshTableEvent';
export const REFRESH_TABLE_PAGE_EVENT = 'refreshTablePageEvent';
export const REFRESH_TABLE_CONTROLS_EVENT = 'refreshTableControlsEvent';
export const REFRESH_TABLE_CONTROLS_SEARCH_EVENT = 'refreshTableControlsSearchEvent';
export const REFRESH_TABLE_CONTROLS_ORDER_EVENT = 'refreshTableControlsOrderEvent';

export const REFRESH_SIMPLE_TABLE_EVENT = 'refreshSimpleTableEvent';
export const REFRESH_NO_COLUMN_TABLE_EVENT = 'refreshNoColumnTableEvent';
export const REFRESH_SERVICES_ENABLED_DEVICE_COUNT = 'refreshServicesEnabledDeviceCount';

export const REFRESH_SOLUTION_PORTFOLIO_EVENT = 'refreshSolutionPortfolioEvent';
export const REFRESH_SOLUTIONS_CATALOG_EVENT = 'refreshSolutionsCatalogEvent';
export const REFRESH_APP_DETAIL_EVENT = 'refreshAppDetailEvent';
export const REFRESH_ACCOUNT_DETAIL_EVENT = 'refreshAccountDetailEvent';
export const REFRESH_PARTNER_ACCOUNT_DETAIL_EVENT = 'refreshPartnerAccountDetailEvent';
export const REFRESH_USER_DETAIL_EVENT = 'refreshUserDetailEvent';
export const REFRESH_TASK_DETAIL_EVENT = 'refreshTaskDetailEvent';
export const REFRESH_TASK_HISTORY_EVENT = 'refreshTaskHistoryEvent';
export const REFRESH_DEVICES_EVENT = 'refreshDevicesEvent';
export const REFRESH_INSTALL_CONFIGURATION_EVENT = 'refreshInstallConfigurationEvent';
export const REFRESH_EDIT_IT_ADMIN_EVENT = 'refreshEditItAdminEvent';

export const REFRESH_INSTALLED_SOLUTIONS_TABLE_EVENT = 'refreshInstalledSolutionsTableEvent';

// close
export const CLOSE_EDIT_IT_ADMIN = 'closeEditITAdmin';

// reset
export const RESET_PAGING_EVENT = 'resetPagingEvent';